import { render, staticRenderFns } from "./SetSchoolPassword.vue?vue&type=template&id=25786388&"
import script from "./SetSchoolPassword.vue?vue&type=script&lang=js&"
export * from "./SetSchoolPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports